/* src/app/main-game/progress-bar/progress-bar.component.scss */
.main-game-progress-group {
  bottom: 0;
  height: 30px;
  width: 100%;
  background-color: transparent;
  position: fixed;
  z-index: 1;
}
.legal {
  display: flex;
  justify-content: flex-end;
  margin: 0 10px 4px 0;
  color: #6E767E;
}
.legal a {
  text-decoration: underline;
  cursor: pointer;
  color: #6E767E;
}
.legal a:hover {
  text-decoration: none;
}
.main-game-progress-group .percentage {
  position: absolute;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: transparent;
  line-height: 30px;
  font-weight: bold;
  font-family: Campton-DEMO, sans-serif;
  font-size: 20px;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: 1px;
  color: #272a33;
}
.main-game-progress-group .played {
  width: 0%;
  opacity: 1;
  height: 30px;
  background-color: #6ccc09;
  float: left;
  -webkit-transition: width 300ms ease-in-out;
  -moz-transition: width 300ms ease-in-out;
  -o-transition: width 300ms ease-in-out;
  transition: width 300ms ease-in-out;
}
.main-game-progress-group .unplayed {
  width: 100%;
  height: 30px;
  opacity: 0.4;
  background-color: #ffffff;
  float: left;
  -webkit-transition: width 300ms ease-in-out;
  -moz-transition: width 300ms ease-in-out;
  -o-transition: width 300ms ease-in-out;
  transition: width 300ms ease-in-out;
}
.main-game-progress-group .current {
  width: 6px;
  opacity: 1;
  height: 30px;
  background-color: #ffffff;
  float: left;
  position: absolute;
  left: 0%;
  -webkit-transition: left 300ms ease-in-out;
  -moz-transition: left 300ms ease-in-out;
  -o-transition: left 300ms ease-in-out;
  transition: left 300ms ease-in-out;
}
/*# sourceMappingURL=progress-bar.component.css.map */
